<template lang="pug">
  #organizations-center
    WtTile(ancestor)
      WtTile(class="custom-container")
        WtTile(vertical)
          WtTile(parent v-if="isProTier")
            OrganizationsTeamsNavigator
          WtTile(parent)
            WtTile(child)
              WtTile(ancestor)
                WtTile(parent :col="6")
                  WtTile(child :col="12").has-background-light
                    GeneralSettings
                WtTile(parent :col="6" vertical)
                  WtTile(child :col="12").has-background-light
                    CreateOrganization
          WtTile(parent)
            ExistingOrganizations
</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import GeneralSettings from "@@/OrganizationsSettingsAdmin/GeneralSettings";
import CreateOrganization from "@@/OrganizationsSettingsAdmin/CreateOrganization";
import ExistingOrganizations from "@@/OrganizationsSettingsAdmin/ExistingOrganizations";
import OrganizationsTeamsNavigator from "@@/OrganizationsSettingsAdmin/OrganizationsTeamsNavigator";
import { mapGetters } from "vuex";

export default {
  name: "OrganizationsCenterSettings",

  components: {
    WtTile,
    GeneralSettings,
    CreateOrganization,
    ExistingOrganizations,
    OrganizationsTeamsNavigator
  },

  computed: {
    ...mapGetters("program", ["isProTier"])
  }
};
</script>

<style lang="sass" scoped>
#organizations-center
  @media screen and (max-width: 1375px)
      flex-direction: column
  .custom-col-7
    @media screen and (max-width: 1375px)
      width: 100%
</style>
